<div class="request-field-filters" *ngIf="!isLoadingLabels">
	<div class="header-wrap">
		<div class="tab selected" [title]="labels.lbl_geral_selecao_filtros_ocultara_campos_correspondentes">
			{{ labels.lbl_filtros_disponiveis }} <fa-icon [icon]="icons.faInfoCircle"></fa-icon>
		</div>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="!isLoadingFilters">
			<cpi-generic-form-gen
				(change)="onSolutionAreaChange($event.target.value)"
				[setGenericForm]="filterOptionsSolutionArea"
				[columns]="1"
				[labels]="labels"
				[columns]="2">
			</cpi-generic-form-gen>

			<cpi-generic-form-gen [setGenericForm]="filterOptionsAnalyst" [columns]="1" [labels]="labels" [columns]="2">
			</cpi-generic-form-gen>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isUpdating }" (click)="saveAnalystsToSolutionArea()">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</ng-container>

		<cpi-dot-bounce-loading-effect *ngIf="isLoadingFilters" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	</div>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingLabels" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
